function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-time_svg__linear-gradient",
  x1: 44.81,
  y1: 23.98,
  x2: 25.21,
  y2: -0.88,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#80e8bb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-time_svg__linear-gradient-2",
  x1: 50.76,
  y1: 81.84,
  x2: 22.26,
  y2: 19.52,
  xlinkHref: "#2-time_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-time_svg__linear-gradient-3",
  x1: 19.63,
  y1: 8.69,
  x2: 36.23,
  y2: 51.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#80e8bb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d2f7e7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-time_svg__linear-gradient-4",
  x1: 40.37,
  y1: 18.92,
  x2: 26.58,
  y2: -8.98,
  xlinkHref: "#2-time_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-time_svg__linear-gradient-5",
  x1: 16.38,
  y1: 15.42,
  x2: 60.98,
  y2: 89.44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#007763"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-time_svg__linear-gradient-6",
  x1: 52.71,
  y1: 54.29,
  x2: 29.34,
  y2: 40.26,
  xlinkHref: "#2-time_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-time_svg__linear-gradient-7",
  x1: 39.48,
  y1: 65.94,
  x2: 28.98,
  y2: 28.76,
  xlinkHref: "#2-time_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("style", null, ".2-time_svg__cls-5{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "2-time_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "2-time_svg__Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#2-time_svg__linear-gradient)",
  d: "M29 4h8v10h-8z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 43,
  r: 33,
  fill: "url(#2-time_svg__linear-gradient-2)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 43,
  r: 26,
  fill: "url(#2-time_svg__linear-gradient-3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33 21v4m0 36v4m22-22h-4m-36 0h-4",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  className: "2-time_svg__cls-5",
  d: "M32 19h2v6h-2zm0 42h2v6h-2zm19-19h6v2h-6zM9 42h6v2H9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "2-time_svg__cls-5",
  transform: "rotate(-45 47.85 28.15)",
  d: "M44.85 27.15h6v2h-6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "2-time_svg__cls-5",
  transform: "rotate(-45 18.153 57.85)",
  d: "M15.15 56.85h6v2h-6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "2-time_svg__cls-5",
  transform: "rotate(-45 47.852 57.85)",
  d: "M46.85 54.85h2v6h-2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "2-time_svg__cls-5",
  transform: "rotate(-45 18.15 28.152)",
  d: "M17.15 25.15h2v6h-2z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 21,
  width: 24,
  height: 8,
  rx: 4,
  fill: "url(#2-time_svg__linear-gradient-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33 19A24 24 0 119 43a24 24 0 0124-24m0-2a26 26 0 1026 26 26 26 0 00-26-26z",
  fill: "url(#2-time_svg__linear-gradient-5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.44 51.47a2 2 0 01-1.44-.58L22.27 35.13a2 2 0 112.83-2.82l15.75 15.75a2 2 0 010 2.83 2 2 0 01-1.41.58z",
  fill: "url(#2-time_svg__linear-gradient-6)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 43,
  r: 6,
  fill: "url(#2-time_svg__linear-gradient-7)"
})));

function Svg2Time(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 66 76"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { Svg2Time as ReactComponent };